import { Bold, Italic } from "tiptap-extensions";

export class BBold extends Bold {
	get name() {
		return "bold";
	}

	get schema() {
		return {
			...super.schema,
			toDOM: () => ["b", 0]
		};
	}

	inputRules() {
		return [];
	}

	pasteRules() {
		return [];
	}
}

export class IItalic extends Italic {
	get name() {
		return "italic";
	}

	get schema() {
		return {
			...super.schema,
			toDOM: () => ["i", 0]
		};
	}

	inputRules() {
		return [];
	}

	pasteRules() {
		return [];
	}
}
